import * as React from "react";
const SvgFiRrFishingRod = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-fishing-rod_svg__a)">
      <path
        fill="#062147"
        d="M22.897 22.122c-.114-.904-.555-1.657-.987-2.199.959-1.047 2.09-2.685 2.09-4.584 0-1.427-.65-2.932-1.882-4.354-1.066-1.23-3.169-1.231-4.237 0C16.65 12.406 16 13.911 16 15.338c0 1.899 1.131 3.536 2.09 4.584-.433.542-.874 1.295-.987 2.199l-.095.753a.998.998 0 0 0 1.309 1.073l1.684-.562 1.684.562q.156.052.316.052a.997.997 0 0 0 .992-1.125l-.095-.753zm-3.505-9.826a.8.8 0 0 1 .607-.277c.136 0 .397.035.607.276.635.734 1.393 1.857 1.393 3.044 0 1.407-1.037 2.712-1.8 3.482l-.079.018-.12.034-.12-.034-.08-.018c-.764-.771-1.8-2.075-1.8-3.482 0-1.187.757-2.31 1.392-3.043M4.999 12c-.591 0-1.142.172-1.607.469C4.417 8.002 7.909 2.314 19 2v5a1 1 0 1 0 2 0V2a2.02 2.02 0 0 0-.609-1.439c-.39-.379-.9-.568-1.442-.565C4.449.411 1.592 9.479 1.096 14.217A2 2 0 0 0 0 16v6c0 1.103.897 2 2 2s2-.897 2-2v-4.172A3.004 3.004 0 0 0 8 15c0-1.654-1.347-3-3.001-3m0 4a1.001 1.001 0 0 1 0-2 1.001 1.001 0 0 1 0 2"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-fishing-rod_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFishingRod;
